import React from 'react';
import { Outlet, Route } from 'react-router';

import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import BibPageRoute from './BibPageRoute';
import AllCommentsPageRoute from './AllCommentsPageRoute';
import AllListsPageRoute from './AllListsPageRoute';
import AllQuotationsPageRoute from './AllQuotationsPageRoute';
import AllReviewsPageRoute from './AllReviewsPageRoute';
import AllRecommendationsPageRoute from './AllRecommendationsPageRoute';
import AllSummariesPageRoute from './AllSummariesPageRoute';
import AllVideosPageRoute from './AllVideosPageRoute';
import MarcPageRoute from './MarcPageRoute';
import AllContentNoticesPageRoute from './AllContentNoticesPageRoute';

const basePath = '/v2/record/:metadataId';

export default (
  <Route
    path={basePath}
    element={
      <MainLayout>
        <Outlet />
      </MainLayout>
    }
  >
    <Route index element={<BibPageRoute />} />
    <Route path={`${basePath}/comments/*`} element={<AllCommentsPageRoute />} />
    <Route path={`${basePath}/quotations/*`} element={<AllQuotationsPageRoute />} />
    <Route path={`${basePath}/summaries/*`} element={<AllSummariesPageRoute />} />
    <Route path={`${basePath}/reviews/*`} element={<AllReviewsPageRoute />} />
    <Route path={`${basePath}/recommendations/*`} element={<AllRecommendationsPageRoute />} />
    <Route path={`${basePath}/lists/*`} element={<AllListsPageRoute />} />
    <Route path={`${basePath}/videos/*`} element={<AllVideosPageRoute />} />
    <Route path={`${basePath}/originalrecord/*`} element={<MarcPageRoute />} />
    <Route path={`${basePath}/contentnotices/*`} element={<AllContentNoticesPageRoute />} />
    <Route path="*" element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
  </Route>
);
